import React, { useCallback } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import MarkdownRender from 'LuxKit/MarkdownRender'

type Props = {
  title: string
  description: string
}

// Preserve plain-text single-newline breaks in legacy voucher copy —
// marked is configured with breaks: false, so convert single \n to hard
// breaks while leaving blank-line paragraph separators intact.
function preserveLineBreaks(content: string): string {
  return content
    .split(/\n{2,}/)
    .map(paragraph => paragraph.replace(/\n/g, '  \n'))
    .join('\n\n')
}

function VoucherDetailsModal({ title, description }: Props) {
  const modalElement = useModalElementContext()

  const onClose = useCallback(() => {
    modalElement.resolve(undefined)
  }, [modalElement])

  return <ModalBase size="L">
    <ModalHeader
      title={title}
      onCloseButtonClick={onClose}
    />
    <ModalBody>
      <ModalContent>
        <MarkdownRender content={preserveLineBreaks(description)} fontSize="medium" />
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default VoucherDetailsModal
